import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/**
 * display information
 * @param {string} label
 * @param {string} value
 * @param {boolean} skipSeparator
 * @param {boolean} disableLoading
 * @param {any} props
 * @returns formatted key-value pair
 */
const DetailEntry = ({
	label,
	value,
	skipSeparator,
	disableLoading,
	...props
}) => {
	return (
		<Stack direction='row' gap={1}>
			<Typography variant='body2' {...props}>
				<b>
					{label}
					{skipSeparator ? null : ': '}
				</b>
				{value ? (
					value
				) : disableLoading ? null : (
					<Skeleton width={100} />
				)}
			</Typography>
		</Stack>
	);
};
export default DetailEntry;
